import React from 'react';

import type { ChatHistoryItem } from '../../api/chat-api';

import { ChatHistoryEntry } from './ChatHistoryEntry';
import type { ChatHistoryEntryProps } from './ChatHistoryEntry';

export type ChatHistoryEntriesProps = {
  activeChatId: ChatHistoryItem['id'] | null;
  chats: ChatHistoryItem[];
  hideChat: ChatHistoryEntryProps['hideChat'];
  renameChat: ChatHistoryEntryProps['renameChat'];
  renamingChatId: ChatHistoryItem['id'] | null;
  setActiveChatId: ChatHistoryEntryProps['setActiveChatId'];
  setRenamingChatId: (chatId: ChatHistoryItem['id'] | null) => void;
  unhideChat: ChatHistoryEntryProps['unhideChat'];
};

export const ChatHistoryEntries = ({
  activeChatId,
  chats,
  hideChat,
  renameChat,
  renamingChatId,
  setActiveChatId,
  setRenamingChatId,
  unhideChat,
}: ChatHistoryEntriesProps) => {
  return chats.map(chat => (
    <ChatHistoryEntry
      key={chat.id}
      chat={chat}
      hideChat={hideChat}
      isActive={chat.id === activeChatId}
      isRenaming={chat.id === renamingChatId}
      renameChat={renameChat}
      setActiveChatId={setActiveChatId}
      setRenaming={renaming => {
        setRenamingChatId(renaming ? chat.id : null);
      }}
      unhideChat={unhideChat}
    />
  ));
};
